export const usePopState = (callback) => {
    const controller = new AbortController();
    const signal = controller.signal;

    onMounted(() => {
        window.addEventListener(
            'popstate',
            callback,
            {
                signal
            }
        );
    });

    onUnmounted(() => {
        controller.abort();
    });

    return {
        cancel: controller.abort
    };
};
